import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { FeatureFlagEffects } from "./feature-flag.effects";

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([FeatureFlagEffects])],
})
export class FeatureFlagModule {}
